import { render, staticRenderFns } from "./TableHeadDataDesign.vue?vue&type=template&id=761d7079"
import script from "./TableHeadDataDesign.vue?vue&type=script&lang=ts"
export * from "./TableHeadDataDesign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports